/**
 * Word-count proxy for “likely smart search / answer-style query,” matching the
 * client rule used to attach smart-search API params (≥3 space-delimited tokens).
 *
 * Independent of `smart_search_enabled` / eligibility. Not a classifier; long
 * keyword searches may over-match and short questions may under-match.
 */
export const hasLikelySmartSearchIntent = (query: string): boolean =>
  query.split(' ').length > 2;
